import Modal from "react-bootstrap/Modal";
import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { setCurrentSongName, setSongsArray } from "../../store/actions";

function AddNewSong(props) {
  const [songName, setSongName] = useState("");
  const [sectionName, setSectionName] = useState("");

  const submitSong = (event) => {
    event.preventDefault(); // Prevent form from refreshing the page

    if (!songName) {
      alert("Please enter a song name");
      return;
    }

    if (!sectionName) {
      alert("Please enter a Artist name");
      return;
    }

    const updatedSongs = { ...props.songsArray };

    if (updatedSongs[songName]) {
      alert("Song already exists!");
      return;
    }

    if (props.editSong) {
      // Editing existing song
      if (props.editSong !== songName) {
        // If the new name is different, update the song name
        updatedSongs[songName] = updatedSongs[props.editSong];
        delete updatedSongs[props.editSong];
        props.setEditSong("");
      }
    } else {
      // Create a new song with the initial section
      updatedSongs[songName] = {
        ["artist"]: [sectionName],
        ["Intro"]: [],
      };
    }

    props.setSongsArray(updatedSongs);
    props.setCurrentSongName(songName);
    setSongName("");
    setSectionName("");
    props.toggleModal();
  };

  const handleSongInputChange = (e) => {
    setSongName(e.target.value);
  };

  const handleSectionInputChange = (e) => {
    setSectionName(e.target.value);
  };

  useEffect(() => {
    if (props.editSong) {
      setSongName(props.editSong);
      setSectionName(props.songsArray[props.editSong]["artist"][0]);
    }
  }, []);

  return (
    <div>
      <Modal
        size="lg"
        show={props.show}
        onHide={() => props.toggleModal()}
        aria-labelledby="vocal-range-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="vocal-range-popup">Add New Song</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitSong}>
            <label htmlFor="song-name">Song Name:</label>
            <input
              type="text"
              id="song-name"
              name="song-name"
              value={songName}
              className="mb-4 form-control form-control-lg"
              onChange={handleSongInputChange}
            />

            <label htmlFor="section-name">Artist Name:</label>
            <input
              type="text"
              id="section-name"
              name="section-name"
              value={sectionName}
              className="mb-4 form-control form-control-lg"
              onChange={handleSectionInputChange}
            />

            <div>
              <button type="submit" className="btn btn_primary btn-lg">
                Add Song
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    songsArray: state.songsArray,
  };
};

const mapDispatchToProps = {
  setSongsArray,
  setCurrentSongName,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewSong);
